import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractRefundPaymentEmailTemplate.Save.IRequest;
type Response = Api.Core.ContractRefundPaymentEmailTemplate.Save.IResponse;
type Headers = Api.Core.ContractRefundPaymentEmailTemplate.Save.IHeaders;
const url = '/api/Management/ContractRefundPaymentEmailTemplate';
export default async function contractRefundPaymentEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
